<div class="toolbar-container">
  <div class="blue-stripe"></div>
  <mat-toolbar fxLayoutAlign="center center" class="p-0">
    <div fxFlex="80" fxLayout="row" fxLayoutAlign="space-between center" fxHide.lt-md>
      <img class="cursor-pointer" routerLink="dashboard" src="assets/images/logo.svg" height="40px" alt="Cinico" />
      <div *ngIf="currentUser" fxLayout="row" fxLayoutGap="10px">
        <ng-container *ngFor="let item of toolbarNavigation">
          <a
            class="nav-btn"
            mat-button
            *ngIf="!item.hidden"
            routerLinkActive="active-links"
            [routerLink]="[item.routeLink]"
            >{{ 'keywords.' + item.routeName | translate }}</a
          >
        </ng-container>
      </div>
      <div *ngIf="!isProfileHidden && currentUser" fxLayout="row" fxLayoutAlign="center center">
        <button mat-icon-button class="nav-btn p-0 mr-10">
          <mat-icon>search</mat-icon>
        </button>
        <div class="cursor-pointer">
          <img
            [matMenuTriggerFor]="matMenu"
            #trigger="matMenuTrigger"
            class="profile-image"
            [src]="profileImage" />
        </div>

        <mat-menu #matMenu="matMenu" xPosition="before">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="p-10">
            <div>
              <img class="profile-image" [src]="profileImage" />
            </div>
            <div fxLayout="column" fxLayoutAlign="center start">
              <div class="person-name-text">{{ currentUser.firstName }} {{ currentUser.lastName }}</div>
              <div class="person-email-text">{{ currentUser.email }}</div>
            </div>
          </div>
          <mat-divider class="mb-15 mt-15"></mat-divider>
          <div
            class="menu-button"
            routerLink="profile/info"
            routerLinkActive="active-links"
            fxFlex="row"
            fxLayoutGap="10px"
            fxLayoutAlign="start center">
            <div class="material-symbols-outlined">settings</div>
            <div>{{ 'keywords.account_settings' | translate }}</div>
          </div>

          <div class="menu-button" fxFlex="row" fxLayoutGap="10px" fxLayoutAlign="start center">
            <div class="material-symbols-outlined">help</div>
            <div>{{ 'keywords.help' | translate }}</div>
          </div>

          <div
            class="menu-button"
            (click)="logout()"
            fxFlex="row"
            fxLayoutGap="10px"
            fxLayoutAlign="start center"
            style="color: red">
            <div class="material-symbols-outlined">exit_to_app</div>
            <div>{{ 'keywords.logout' | translate }}</div>
          </div>
        </mat-menu>
      </div>
    </div>

    <div fxHide.gt-sm fxLayout="row" fxLayoutAlign="space-between center" class="w-90 mt-10">
      <img
        class="cursor-pointer logo-small"
        routerLink="dashboard"
        src="assets/images/logo.svg"
        height="40px"
        alt="Cinico" />

      <button
        mat-icon-button
        fxLayout="center center"
        (click)="toggleRightSidebar((rightStateSidebar = !rightStateSidebar))">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
  </mat-toolbar>
</div>
